import { z } from 'zod';
/** Allowed video MIME types for recorded classes. */
export const RECORDING_MIME_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'];
/** Max recording size in bytes (2 GB). */
export const MAX_RECORDING_BYTES = 2 * 1024 * 1024 * 1024;
const recordingMime = z.enum(RECORDING_MIME_TYPES);
const recordingSize = z
    .number()
    .int()
    .positive('El tamaño debe ser positivo')
    .max(MAX_RECORDING_BYTES, 'El vídeo supera el límite de 2 GB');
/** Step 1: director requests a signed URL to upload the video directly to Storage. */
export const signRecordingUploadSchema = z.object({
    opposition_id: z.string().uuid(),
    file_name: z.string().min(1).max(255),
    mime_type: recordingMime,
    file_size_bytes: recordingSize,
});
/** Step 2: after the direct upload, register the recording metadata. */
export const registerRecordingSchema = z.object({
    opposition_id: z.string().uuid(),
    title: z.string().trim().min(1, 'El título es obligatorio').max(200),
    description: z.string().max(2000).optional(),
    file_path: z.string().min(1).max(1024),
    file_size_bytes: recordingSize,
    mime_type: recordingMime,
    duration_seconds: z.number().int().min(0).optional(),
});
/** Grant a single student access to a recording. */
export const grantRecordingPermissionSchema = z.object({
    student_id: z.string().uuid(),
});
//# sourceMappingURL=recording.schema.js.map